import { inject } from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthLoginService} from "../../componentes/autenticacion/services/auth-login.service";


export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthLoginService);
  const router = inject(Router);

  if (authService.loggedIn()) {
    return true;
  }

  // Redirect to the login page
  return router.navigate(['/login-form']);
};
